module.exports = __webpack_public_path__ + "media/images/icons/vastaanbod-16ea809797a97232a953473ddaf17886.svg";